@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';
@import (reference) '../../settings-page.module.less';

.card {
  flex: 1;
  padding-top: @space-16;
  padding-left: @space-16;
  padding-right: @space-16;
  border: @settings-page--table--border;
  border-radius: 4px;
}

.header {
  align-items: center;
  justify-content: space-between;
  margin-bottom: @space-12;
}

.plan-details-link {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.progress-bar-wrapper {
  border-radius: 4px;
  height: 8px;
  margin-bottom: @space-16;
}

.progress-bar {
  border-radius: 4px;
  margin-bottom: @space-8;
  background: var(--green-05B45E);
}

.count-row {
  align-items: center;
  margin-top: auto;
}

.count {
  font-weight: 600;
}

.count-row-button {
  margin-left: @space-8;
}
